
import apiClient from '../helpers/apiClient';
import { authHeader } from '../helpers/authHeader';



export const productionSetupService = {
    getProductionSetupList, productionSearch, productionDetails,
    productionFinishedItem, deleteProduction, submitProductionSetup

};




async function  getProductionSetupList() {
   return apiClient.get(`/production-setup/production-setup-list`,  authHeader());
}



// async function  productionListByDate(dateForm) {
//     return  apiClient.post(`/production-setup/production-setup-by-date`,dateForm, authHeader());
// }


async function  submitProductionSetup(dateForm) {
    return  apiClient.post(`/production-setup/submit-setup-production`,dateForm, authHeader());
}

async function  productionSearch(searchText) {
    return  apiClient.get(`/production-setup/production-search?search=${searchText}`, authHeader());
}

async function  productionDetails(ProductionId) {
    return  apiClient.get(`/production-setup/production-setup-details/${ProductionId}`, authHeader());
}


async function  deleteProduction(ProductionId) {
    return  apiClient.delete(`/production-setup/delete-setup-production/${ProductionId}`, authHeader());
}

async function  productionFinishedItem(ProductionId) {
    return  apiClient.get(`/production-setup/production-finished-item/${ProductionId}`, authHeader());
}












